<template>
  <el-upload
    class="multi-uploader"
    action="#"
    accept="image/*"
    :on-change="handleAvatarChange"
    :on-remove="removeImg"
    :auto-upload="false"
    list-type="picture-card"
    multiple
    :file-list="list"
  >
    <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" />
    <p v-else><img src="@/assets/addphoto.png" alt="" /></p> -->
    <div class="addbox">
      <i class="el-icon-plus"></i>
      <div>{{ uploadText }}</div>
    </div>
  </el-upload>
</template>

<script>
export default {
  props: {
    uploadText: {
      type: String,
      default: "上传图片",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      imageUrl: "",
    };
  },
  computed: {
    // imageUrl: {
    //   get() {
    //     return this.list;
    //   },
    //   set(val) {
    //     this.$emit("update:list", val);
    //   },
    // },
  },
  created() {},
  mounted() {},
  methods: {
    handleAvatarChange(file, fileList) {
      // console.log("file :>> ", file);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit("avatarFile", file, fileList);
    },
    removeImg(file, fileList) {
      this.$emit("removeFile", file, fileList);
    },
  },
};
</script>
<style lang="scss" scoped>
.multi-uploader {
  ::v-deep .el-upload-list {
    .el-upload-list__item {
      width: 104px;
      height: 104px;
    }
    .el-upload-list__item-status-label {
      display: none;
    }
  }

  ::v-deep .el-upload {
    width: 104px;
    height: 104px;
    // background: rgba(0, 0, 0, 0.02);
    .addbox {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .el-icon-plus {
        font-weight: bold;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 10px;
        font-size: 24px;
      }
    }
  }
}
</style>
